import React, { useMemo } from 'react';

import { Integration } from 'src/common/interfaces/integration.interface';
import { AddStrongIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';
import { InlineLoadingSpinner } from 'src/common/components/loading-spinner';

interface Props {
  apiKeysLoaded: boolean;
  integration: Integration;
  onConnectClicked: () => void;
  apiKeyList: Nullable<JSX.Element>;
  isParagonIntegrationEnabled: boolean;
  hasApiKey: boolean;
}

const IntegrationDetail = ({
  integration: { is_static, form_placeholder, name, how_does_it_work_copy, allowMultiple, code },
  apiKeyList,
  isParagonIntegrationEnabled,
  apiKeysLoaded,
  onConnectClicked,
  hasApiKey,
}: Props) => {
  const connectText = useMemo(() => {
    if (is_static) {
      return form_placeholder;
    } else if (code === 'hubspot-tracker') {
      return `Add ${name} code`;
    }

    return `Connect ${name} account`;
  }, [code, form_placeholder, is_static, name]);

  const isButtonVisible = allowMultiple || !hasApiKey || is_static;

  return (
    <div className='flex flex-col mt-4 space-y-6 text-bedrock-black'>
      <h1 className='text-bedrock-h1 font-brand-serif capitalize'>{name}</h1>

      <div className='flex flex-col space-y-6 max-w-[600px]'>
        <div className='col-span-5 flex flex-col space-y-2'>
          <h2 className='text-bedrock-p-strong'>How does it work?</h2>
          {typeof how_does_it_work_copy === 'string' ? (
            <p className='text-bedrock-p'>{how_does_it_work_copy}</p>
          ) : (
            how_does_it_work_copy
          )}
        </div>
        {apiKeysLoaded ? (
          <div className='space-y-6'>
            {apiKeyList && apiKeyList}
            {!isParagonIntegrationEnabled && isButtonVisible && (
              <button onClick={onConnectClicked} className='btn-bedrock-secondary self-start flex space-x-1'>
                <AddStrongIcon />
                <span>{connectText}</span>
              </button>
            )}
          </div>
        ) : (
          <InlineLoadingSpinner />
        )}
      </div>
    </div>
  );
};

export default IntegrationDetail;
